import { useAppDispatch, useAppSelector } from '@hooks/useRedux';
import {
  fetchAllCompanyPropertiesThunk,
  fetchPropertyThunk,
} from '@store/accommodation';
import {
  selectAllOutlets,
  selectEffectiveOutletId,
  setSelectedOutletId,
} from '@store/outlets';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export const AccommodationLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const outletId = useAppSelector(selectEffectiveOutletId);
  const outlets = useAppSelector(selectAllOutlets);

  useEffect(() => {
    if (!outletId && outlets.length > 0) {
      dispatch(setSelectedOutletId(outlets[0].id));
    }
  }, [dispatch, outletId, outlets]);

  useEffect(() => {
    if (outletId) {
      // Specific outlet selected → load its property (read only; properties
      // are created explicitly from Settings → Properties)
      dispatch(fetchPropertyThunk(outletId));
    } else {
      // No outlet selected (e.g. multi-outlet admin viewing all) →
      // fetch all company properties and use the first one
      dispatch(fetchAllCompanyPropertiesThunk());
    }
  }, [dispatch, outletId]);

  return <Outlet />;
};
